// src/pages/CollectionsPage.tsx

import React from 'react';
import { useParams } from 'react-router-dom';
import CollectionsPreview from '../../components/Collections';

const CollectionsPage: React.FC = () => {
  const { page } = useParams<{ page: string }>();

  return (
    <div>
      {page === 'ckb' && <h1>CKB Page</h1>}
      {page === 'fotr' && <h1>FOTR Page</h1>}
      <CollectionsPreview />
    </div>
  );
};

export default CollectionsPage;
